module.exports = __webpack_public_path__ + "img/nights.31f0a479.svg";